"use client";
import { apiSdkInstance } from "@/apiSdk/stageApiSdk.instance";
import { WindowEventListenersEnum } from "@/constants/constants";
import { usePaymentPolling } from "@/hooks/usePaymentPolling";
import { PostWatchVideoEventsReq } from "@/types/consumption.types";
import { TriggerPostWatchVideoEventParams } from "@/types/payment.types";
import { useEffect } from "react";

export const RegisterEventListeners = () => {
  usePaymentPolling();

  useEffect(() => {
    const triggerPostWatchVideoEvents = (
      event: CustomEvent<TriggerPostWatchVideoEventParams>,
    ) => {
      const props = event.detail;
      apiSdkInstance.consumption.postWatchVideoEvents(props);
    };

    window.addEventListener(
      WindowEventListenersEnum.TRIGGER_POST_WATCH_VIDEO,
      triggerPostWatchVideoEvents as EventListener,
    );

    return () => {
      window.removeEventListener(
        WindowEventListenersEnum.TRIGGER_POST_WATCH_VIDEO,
        triggerPostWatchVideoEvents as EventListener,
      );
    };
  }, []);

  return null;
};
